module.exports = __webpack_public_path__ + "media/images/card-reader-payment-bdcfcc9d3e7e13141b130acc8b4f28a9.svg";